import type { WorkOrderOtherAggregationData } from 'gql/graphql';

import { useMemo } from 'react';

import type { IOthersObject } from './types';

export const useAddOtherData = ({
    workOrderOthers,
    workOrderObjects,
    constructionTypeId,
}: {
    workOrderOthers: Partial<WorkOrderOtherAggregationData>[];
    workOrderObjects: IOthersObject[];
    constructionTypeId: number;
}) => {
    const preparedWorkOrderObjects = useMemo(
        () =>
            workOrderObjects.filter(
                ({ parentId, constructionType }) => parentId === null && constructionTypeId === constructionType.id,
            ),
        [constructionTypeId, workOrderObjects],
    );

    return useMemo(
        () =>
            workOrderOthers.map((workOrderOther) => ({
                ...workOrderOther,
                rows: preparedWorkOrderObjects.map((workOrderObject) => ({
                    ...workOrderObject,
                    id: `${workOrderOther.contractOtherCostId}_${workOrderObject.id}`,
                    objectId: workOrderObject.id,
                    parentId: workOrderOther.contractOtherCostId,
                })),
                id: workOrderOther.contractOtherCostId,
            })),
        [preparedWorkOrderObjects, workOrderOthers],
    );
};
